import {Apollo, gql} from 'apollo-angular';
import {DocumentNode, FetchResult} from '@apollo/client/core';

import {Injectable} from '@angular/core';

import {BaseRepository} from '@galec/repositories/baseRepository';
import {Observable} from 'rxjs';

import {UserAuthenticationService} from "@galec/services/user/user-authentication.service";
import {IInformationsReglementairesParite} from "@models/informationsReglementairesParite.interface";


@Injectable({
    providedIn: 'root'
})
/**
 * Horaire repository service.
 */
export class InfosReglementairesPariteRepository extends BaseRepository {

    protected DELETE_QUERY: DocumentNode;
    protected INSERT_QUERY: DocumentNode;
    protected LIST_QUERY: DocumentNode;
    protected UPDATE_QUERY: DocumentNode;

    constructor(protected apollo: Apollo, protected userAuthenticationService: UserAuthenticationService) {
        super();
        this.init();
    }

    public updateInformationsReglementairesParite(infos_parite: IInformationsReglementairesParite): Observable<FetchResult<{}>> {
        return this.mutationHandler(updateInformationsReglementairesParite, {
            id: infos_parite.id,
            ecart_remuneration: infos_parite.ecart_remuneration,
            parite_haute_remuneration: infos_parite.parite_haute_remuneration,
            pourcentage_salarie_augmentation_individuelles: infos_parite.pourcentage_salarie_augmentation_individuelles,
            ecart_taux_augmentation_individuelles: infos_parite.ecart_taux_augmentation_individuelles,
            ecart_taux_promotion: infos_parite.ecart_taux_promotion,
        });
    }

    public selectInfosReglementairesPariteById(id_base_adherent): Observable<any> {
        return this.queryHandler(selectInfosReglementairesPariteById, {id_base_adherent});
    }
}

export const ALL_INFORMATIONS_REGLEMENTAIRES_PARITE_FIELD = `
    id
    id_base_adherent
    ecart_remuneration
    parite_haute_remuneration
    pourcentage_salarie_augmentation_individuelles
    ecart_taux_augmentation_individuelles
    ecart_taux_promotion
    updated_at
`;

const selectInfosReglementairesPariteById = gql`
    query selectInfosReglementairesPariteById($id_base_adherent: String!) {
        informations_reglementaires_parite(where: {id_base_adherent: {_eq: $id_base_adherent}}) {
            ${ALL_INFORMATIONS_REGLEMENTAIRES_PARITE_FIELD}
        }
    }
`;


const updateInformationsReglementairesParite = gql `
    mutation updateInformationsReglementairesParite(
        $id: Int!,
        $ecart_remuneration: Int!,
        $parite_haute_remuneration: Int!,
        $pourcentage_salarie_augmentation_individuelles: Int!,
        $ecart_taux_augmentation_individuelles: Int!,
        $ecart_taux_promotion: Int!,
    ) {
    update_informations_reglementaires_parite(
        where: {
            id: {_eq: $id}
        },
        _set: {
            ecart_remuneration: $ecart_remuneration,
            parite_haute_remuneration: $parite_haute_remuneration,
            pourcentage_salarie_augmentation_individuelles: $pourcentage_salarie_augmentation_individuelles,
            ecart_taux_augmentation_individuelles: $ecart_taux_augmentation_individuelles,
            ecart_taux_promotion: $ecart_taux_promotion,
        }
    ) {
      affected_rows
    }
  }
`;
